// extracted by mini-css-extract-plugin
module.exports = {"form-container":"SendForm_form-container__1UIrM","amount-sign":"SendForm_amount-sign__1Ixo0","amount":"SendForm_amount__2O_NM"};